// Global Enums
import {
  webPages,
  webSections,
} from 'common.enums';

// Global Components
import * as React from 'react';

// Components
import Page from '../../layout/Page';
import NotFoundSection from '../../sections/CommonSections/NotFoundSection';

const NotFoundPageView = function () {
  return (
    <Page
      id={webPages.notFoundPage}
      tags={{
        title: 'Page not found',
      }}
    >
      <NotFoundSection id={webSections[webPages.notFoundPage].notFound} />
    </Page>
  );
};

export default NotFoundPageView;
